import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CodeBlockProps {
  code: string;
  language?: string;
}

export default function CodeBlock({ code, language }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group rounded-subtle bg-navy-900 border border-navy-800/50 overflow-hidden my-4">
      <div className="flex items-center justify-between px-4 py-2 border-b border-navy-800/30">
        {language ? (
          <span className="font-mono text-[10px] text-bone-white/30 uppercase tracking-wider">{language}</span>
        ) : (
          <span />
        )}
        <button
          onClick={handleCopy}
          className="ml-auto font-mono text-[10px] text-bone-white/20 hover:text-bone-white/60 transition-colors flex items-center gap-1.5"
        >
          {copied ? <Check size={12} /> : <Copy size={12} />}
          <span>{copied ? 'Copied' : 'Copy'}</span>
        </button>
      </div>
      <pre className="p-4 overflow-x-auto">
        <code className="font-mono text-xs text-bone-white/80 leading-relaxed whitespace-pre">{code}</code>
      </pre>
    </div>
  );
}
